import React, { useState } from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import { shirtSizes } from '../data/site';
const label = 'text-sm font-bold uppercase tracking-wide text-gray-400';
export function ChampionShirtPurchase() {
  const {
    addToCart
  } = useSession();
  const [size, setSize] = useState<string | null>(null);
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const handleAdd = () => {
    if (!size) {
      setSizeError(true);
      return;
    }
    addToCart(qty);
    setAdded(true);
  };
  return <div data-id="element-52" data-mp="3ic4hct1ciae9">
      <p className={label} data-id="element-53" data-mp="3djl4xzee9lb1">Description</p>

      <fieldset className="mt-6" data-id="element-54" data-mp="3dijoffem06lx">
        <legend className="flex items-center gap-4" data-id="element-55" data-mp="3dhi4smjj2bsl">
          <span className={label} data-id="element-56" data-mp="2psyuk1gx3oxv">Size</span>
          <span className="text-sm text-[#1F3BB3] underline" data-id="element-57" data-mp="2prw41uniboih">Size Chart</span>
        </legend>
        <div className="mt-3 flex flex-wrap gap-2" data-id="element-58" data-mp="2kstb38ksx8qv">
          {shirtSizes.map(s => <button key={s} type="button" aria-pressed={size === s} onClick={() => {
          setSize(s);
          setSizeError(false);
          setAdded(false);
        }} className={`rounded border-2 px-3 py-1.5 text-[17px] transition-colors duration-150 ${size === s ? 'border-navy bg-navy text-white' : 'border-gray-300 text-gray-600 hover:border-navy'}`} data-id="element-59" data-mp="18fdm9spi1pwp">
              {s}
            </button>)}
        </div>
        {sizeError && <p role="alert" className="mt-2 text-sm font-medium text-brand-red" data-id="element-60" data-mp="ygofow31zrvr">Choose a size to continue.</p>}
      </fieldset>

      <div className="mt-10" data-id="element-61" data-mp="13hu5om5bx11l">
        <label htmlFor="qty" className={label} data-id="element-62" data-mp="29wv6b55au7ei">Quantity</label>
        <select id="qty" value={qty} onChange={e => setQty(Number(e.target.value))} className="mt-2 block h-10 w-20 rounded border-2 border-gray-300 px-2 text-[17px] outline-none focus:border-navy" data-id="element-63" data-mp="29wd2nngb4qwk">
          {[1, 2, 3, 4, 5].map(n => <option key={n} value={n} data-id="element-64" data-mp="1k7xxx4ky77e5">{n}</option>)}
        </select>
      </div>

      <div className="mt-8 flex items-center gap-4" data-id="element-65" data-mp="1z5835w6zzh1f">
        <span className={label} data-id="element-66" data-mp="1u6wuhosfvcks">Price</span>
        <span className="text-sm text-[#1F3BB3] underline" data-id="element-67" data-mp="1u76kvdheblr0">Shipping Details</span>
      </div>
      <p className="mt-2 text-3xl font-bold text-[#1F3BB3]" data-id="element-68" data-mp="16hufypt3pzui">$24.99</p>

      <button onClick={handleAdd} className={`mt-6 flex items-center gap-2 rounded border-2 px-4 py-2 text-xl transition-colors duration-150 ${added ? 'border-go bg-go text-white' : 'border-gray-400 text-gray-600 hover:border-navy hover:text-navy'}`} data-id="element-69" data-mp="11ihqdxauieo8">
        {added ? <CheckIcon className="h-5 w-5" aria-hidden data-id="element-70" data-mp="npru901lrtde" /> : <PlusIcon className="h-5 w-5" aria-hidden data-id="element-71" data-mp="nogq2z48wjlr" />}
        {added ? 'Added to Cart' : 'Add to Cart'}
      </button>
    </div>;
}